__turbopack_context__.v({
  "cta-link": "FooterNavigationMenu-module-scss-module__x2dvZq__cta-link",
  "cta-menu": "FooterNavigationMenu-module-scss-module__x2dvZq__cta-menu",
  "menu": "FooterNavigationMenu-module-scss-module__x2dvZq__menu",
  "menu__a": "FooterNavigationMenu-module-scss-module__x2dvZq__menu__a",
  "menu__li": "FooterNavigationMenu-module-scss-module__x2dvZq__menu__li",
  "menu__ul": "FooterNavigationMenu-module-scss-module__x2dvZq__menu__ul",
  "nav": "FooterNavigationMenu-module-scss-module__x2dvZq__nav",
  "parentCategory": "FooterNavigationMenu-module-scss-module__x2dvZq__parentCategory",
});
